import { render, staticRenderFns } from "./SingleCellProject.vue?vue&type=template&id=76873cca&scoped=true"
import script from "./SingleCellProject.vue?vue&type=script&lang=js"
export * from "./SingleCellProject.vue?vue&type=script&lang=js"
import style0 from "./SingleCellProject.vue?vue&type=style&index=0&id=76873cca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76873cca",
  null
  
)

export default component.exports